import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/businessHoursApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
//Import Widgets
import BusinessHoursTemplateWidget from "../../../../components/Apps/BusinessHours/Template/BusinessHoursTemplateWidget";
import FullBusinessDetailTemplateWidget from "../../../../components/Apps/BusinessHours/Template/FullBusinessDetailTemplateWidget";
import OpenStatusTemplateWidget from "../../../../components/Apps/BusinessHours/Template/OpenStatusTemplateWidget";
import HoursContactsTemplateWidget from "../../../../components/Apps/BusinessHours/Template/HoursContactsTemplateWidget";
import SmallContactsCardTemplateWidget from "../../../../components/Apps/BusinessHours/Template/SmallContactsCardTemplateWidget";
import DarkContactsCardTemplateWidget from "../../../../components/Apps/BusinessHours/Template/DarkContactsCardTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/BusinessHours/ContentTab";
import LayoutTab from "../../../../components/Apps/BusinessHours/LayoutTab";
import StyleTab from "../../../../components/Apps/BusinessHours/StyleTab";
import SettingTab from "../../../../components/Apps/BusinessHours/SettingTab";

export default function CreateAgeVerification() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Business Hours");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);

    const [businessHoursTabData, setBusinessHoursTabData] = useState({
        is_website_frontend: "",  
        is_sunday_on: 0,  
        sunday_start_time: "8:00 AM",  
        sunday_end_time: "5:00 PM",
        is_monday_on: 1,  
        monday_start_time: "8:00 AM",  
        monday_end_time: "5:00 PM",  
        is_tuesday_on: 1,  
        tuesday_start_time: "8:00 AM",  
        tuesday_end_time: "5:00 PM",  
        is_wednesday_on: 1,  
        wednesday_start_time: "8:00 AM",  
        wednesday_end_time: "5:00 PM",  
        is_thursday_on: 1,  
        thursday_start_time: "8:00 AM",  
        thursday_end_time: "5:00 PM",  
        is_friday_on: 1,  
        friday_start_time: "8:00 AM",  
        friday_end_time: "5:00 PM",  
        is_saturday_on: 1,  
        saturday_start_time: "8:00 AM",  
        saturday_end_time: "5:00 PM",
        business_name: "",        
        about_company: "",        
        phone_number: "",        
        email: "",        
        website: "",        
        address: "",   
        is_show_labels_on: 1,  
        is_show_icons_on: 1, 
        layout_is_full_width: "",    
        layout_custom_width: "auto",       
        position_alignment: "left",       
        background_color: "",       
        text_color: "#000",       
        icons_color: "#000",       
        open_status_color: "#F9AF63",       
        closed_status_color: "#B82D2D",       
        closed_soon_status_color: "#FF6600",       
        font_type: "Default",       
        text_size: "18px",       
        language_type: "English",       
        time_zone: "(GMT+05:30) Asia/Kolkata",       
        time_format: "12-hour",       
        first_day_of_the_week: "Monday",       
        day_and_month_format: "Full (Monday, January)",       
        custom_css: "",    
        custom_js: "",    
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateBusinessHoursTabData = (key, value) => {
        setBusinessHoursTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Style", icon: "style.png", label: "Style" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setBusinessHoursTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setBusinessHoursTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(businessHoursTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/business-hours');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/business-hours/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Content" && (
                        <ContentTab updateBusinessHoursTabData={updateBusinessHoursTabData} businessHoursTabData={businessHoursTabData} />
                    )}
                    {activeSection === "Layout" && (
                        <LayoutTab updateBusinessHoursTabData={updateBusinessHoursTabData} businessHoursTabData={businessHoursTabData} />
                    )}
                    {activeSection === "Style" && (
                        <StyleTab updateBusinessHoursTabData={updateBusinessHoursTabData} businessHoursTabData={businessHoursTabData}/>
                    )}
                    {activeSection === "Settings" && (
                        <SettingTab updateBusinessHoursTabData={updateBusinessHoursTabData} businessHoursTabData={businessHoursTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/business-hours"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/business-hours/business-hours.svg`} alt="business-hours"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/business-hours/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/business-hours" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Business Hours <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Business_Hours_Temp" && (
                      <BusinessHoursTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Full_Business_Detail_Temp" && (
                      <FullBusinessDetailTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Open_Status_Temp" && (
                      <OpenStatusTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Hours_Contacts_Temp" && (
                      <HoursContactsTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Small_Contacts_Card_Temp" && (
                      <SmallContactsCardTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Dark_Contacts_Card_Temp" && (
                      <DarkContactsCardTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 